import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import CssTransition from "./css-transition";

function HelpCenter({ align }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const trigger = useRef(null);
  const dropdown = useRef(null);

  const help_center_urls  = {
    "guides" : "https://scribehow.com/page/Shiperone_Workflows__FFal8HWER_2GM3SMvxtvAQ",
    "faqs" : "https://www.shiperone.com/faqs",
    "reports" : "https://www.wrike.com/frontend/requestforms/index.html?token=eyJhY2NvdW50SWQiOjYwMjAzODAsInRhc2tGb3JtSWQiOjExMDQyMzl9CTQ4NjMxNjIzNDQyMTIJNjhkZmZlYTBlMzBmOWYyYTdiYWRmM2ZjMTdiYmM2MTg0N2JlZTUyZDU0MzEzY2YwYmViNTlmMjI0M2FkNjExOA==",
  }

  // close on click outside
  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!dropdown.current) return;
      if (
        !dropdownOpen ||
        dropdown.current.contains(target) ||
        trigger.current.contains(target)
      )
        return;
      setDropdownOpen(false);
    };
    document.addEventListener("click", clickHandler);
    return () => document.removeEventListener("click", clickHandler);
  });

  // close if the esc key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!dropdownOpen || keyCode !== 27) return;
      setDropdownOpen(false);
    };
    document.addEventListener("keydown", keyHandler);
    return () => document.removeEventListener("keydown", keyHandler);
  });

  const handleOnClick = (menu) => {
    setDropdownOpen(false);
    setTimeout(() => {
      window.open(help_center_urls[menu], "_blank");
    }, 300);
  }

  return (
    <div className="relative inline-flex">
      <button
        ref={trigger}
        className={`w-8 h-8 flex items-center justify-center bg-slate-100 hover:bg-slate-200 transition duration-150 rounded-full ${
          dropdownOpen && "bg-slate-200"
        }`}
        aria-haspopup="true"
        onClick={() => setDropdownOpen(!dropdownOpen)}
        aria-expanded={dropdownOpen}
      >
        <span className="sr-only">Help Center</span>
        <span className="fas fa-circle-question fill-current"></span>
      </button>

      <CssTransition
        className={`origin-top-right z-10 absolute top-full w-52 bg-white border border-slate-200 py-1.5 rounded shadow-lg overflow-hidden mt-1 ${
          align === "right" ? "right-0" : "left-0"
        }`}
        show={dropdownOpen}
        enter="transition ease-out duration-200 transform"
        enterStart="opacity-0 -translate-y-2"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-out duration-200"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
      >
        <div
          ref={dropdown}
          onFocus={() => setDropdownOpen(true)}
          onBlur={() => setDropdownOpen(false)}
        >
          <div className="pt-0.5 pb-2 px-3 mb-1 border-b border-slate-200">
            <div className="font-medium text-slate-800">Help Center</div>
          </div>

          <ul>
            <li>
              <button
                className="font-medium text-sm text-[--bg-color-500] hover:text-[--bg-color-600] flex items-center py-1 px-3"
                onClick={() => {
                    handleOnClick("guides")
                }}
              >
                How To... Guides
              </button>
            </li>
            <li>
              <button
                className="font-medium text-sm text-[--bg-color-500] hover:text-[--bg-color-600] flex items-center py-1 px-3"
                onClick={() => {
                  handleOnClick("faqs");
                  }}
              >
                FAQs
              </button>
            </li>
            <li>
              <button
                className="font-medium text-sm text-[--bg-color-500] hover:text-[--bg-color-600] flex items-center py-1 px-3"
                onClick={() => {
                  handleOnClick("reports");
                  }}
              >
                Report an Issue
              </button>
            </li>
          </ul>
        </div>
      </CssTransition>
    </div>
  );
}

export default HelpCenter;
